
import { BlogPost } from './types';

// Blog posts for the "Inspiration og motivation" category
export const inspirationPosts: BlogPost[] = [
  {
    id: 5,
    title: "Glæden ved at kunne spille musik",
    slug: "glaeden-ved-at-kunne-spille-musik",
    excerpt: "Der er noget helt særligt ved selv at kunne spille musik. Uanset om det er en enkel melodi eller en hel sang, giver det en følelse af stolthed og ro, når hænderne finder de rigtige tangenter og musikken begynder at tage form.",
    content: `<h2 class="text-2xl md:text-3xl font-serif font-bold mb-6">Glæden ved at kunne spille musik</h2>

<p>Der er noget helt særligt ved selv at kunne spille musik. Uanset om det er en enkel melodi eller en hel sang, giver det en følelse af stolthed og ro, når hænderne finder de rigtige tangenter og musikken begynder at tage form.</p>

<hr />

<h3 class="text-xl md:text-2xl font-serif font-semibold mb-4">Musik giver energi og nærvær</h3>

<p>Når man spiller musik, kommer man helt ned i kroppen. Tankerne falder lidt til ro, og man får lov til at fokusere på noget konkret og kreativt. Det kan være en pause fra en travl hverdag eller en måde at koble af på efter arbejde eller skole. Mange oplever, at de får mere energi og bedre humør, når de har spillet bare et kvarter.</p>

<hr />

<h3 class="text-xl md:text-2xl font-serif font-semibold mb-4">En færdighed, du har med dig hele livet</h3>

<p>At kunne spille klaver er noget, du kan have glæde af hele livet. Det er ikke noget, man "vokser fra", og du behøver ikke være ekspert for at nyde det. Selv simple stykker kan lyde rigtig godt og give en følelse af, at man skaber noget. Og jo mere du øver, jo mere kan du få ud af det.</p>

<hr />

<h3 class="text-xl md:text-2xl font-serif font-semibold mb-4">Musik samler og kan deles</h3>

<p>Noget af det bedste ved musik er, at det kan deles med andre. Du kan spille for familie, venner eller bare for dig selv. Det handler ikke om at imponere – det handler om at være til stede og skabe stemning. Et stykke musik kan sige mere end mange ord, og det er en måde at komme i kontakt med både dig selv og dem, der lytter.</p>

<hr />

<h3 class="text-xl md:text-2xl font-serif font-semibold mb-4">Det er aldrig for sent at starte</h3>

<p>Mange tror, at man skal begynde som barn for at kunne spille, men det passer ikke. Du kan komme i gang som voksen, og du vil stadig opleve, at det er både sjovt, lærerigt og meningsfuldt. Jeg har undervist både børn og voksne, og det vigtigste er lysten – ikke alder eller erfaring.</p>

<p><a href="/kontakt" class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">Book en gratis prøvelektion</a></p>`,
    date: "15.01.2025",
    author: "Oscar Gilbert",
    category: "Inspiration og motivation",
    tags: ["motivation", "glæde", "musik", "velvære", "mindfulness"],
    readTime: "4 min",
    image: "/lovable-uploads/e30322cd-5c82-4734-b8a0-a769d4429241.png"
  }
];
